import { Fragment } from 'react';
import { cardSrc, parsePoker6Cards, parsePoker6Rdesc } from './resultParsers';

export default function Poker6Result({ detail }) {
  const cards = parsePoker6Cards(detail?.card);
  const winner = String(Number(detail?.win || 0) - 10);
  const rdesc = parsePoker6Rdesc(detail?.rdesc);

  return (
    <div className="row row5 poker6result">
      <div className="col-12 col-lg-8">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards casino-open-result">
              {cards.players.map((pCards, idx) => {
                const num = String(idx + 1);
                const isWinner = winner === num;
                return (
                  <div key={idx} className="casino-open-result-item">
                    <h4>{num}</h4>
                    <div className="casino-result-cards">
                      <div className="casino-result-cards-item-container">
                        {pCards.map((code, i) => (
                          <Fragment key={i}>
                            {i > 0 && ' '}
                            <div className="casino-result-cards-item">
                              <img src={cardSrc(code)} alt={code} />
                            </div>
                          </Fragment>
                        ))}
                        {' '}
                        {isWinner && (
                          <div className="casino-result-cards-item">
                            <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="casino-result-content-diveder"></div>
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              <div className="d-inline-block">
                <h4>Board Card</h4>
                {cards.board.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Player <span className="float-right">:</span></div>
            {' '}
            <div>{detail?.winnat || rdesc.winner || '-'}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Pattern<span className="float-right">:</span></div>
            {' '}
            <div>{rdesc.pattern || '-'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
